import EntityAudits from "@/components/EntityAudits.vue";
import { LE } from "@/constants/enums";
import {
  EntityDocumentForm,
  EntityDocumentMultipleForm,
  EntityDocumentsChildList,
} from "@modernary/mui/components/document";
import { EntityNotes } from "@modernary/mui/components/note";
import { RouterView, type RouterOptions } from "vue-router";
import type IncidentChildList from "./IncidentChildList.vue";
import type SiteChildList from "./SiteChildList.vue";

const names = {
  organizations: "Organization.Organization",
  list: "Organization.Organizations",
  new: "Organization.OrganizationNew",
  base: "Organization.OrganizationBase",
  view: "Organization.OrganizationView,",
  edit: "Organization.OrganizationEdit",
  audit: "Organization.OrganizationAudit",
  incidentChildList: "Organization.OrganizationIncidents",
  siteChildList: "Organization.OrganizationSites",
};

export { names as OrganizationRouteNames };

const OrganizationRoutes: RouterOptions["routes"] = [
  {
    path: "/organizations",
    name: names.organizations,
    component: {
      render: () => <RouterView />,
    },
    redirect: { name: names.list },
    children: [
      {
        path: "list",
        name: names.list,
        meta: {
          title: "Organizations",
        },
        component: () => import("@/views/organization/OrganizationList.vue"),
      },
      {
        path: "new",
        component: () => import("@/views/organization/OrganizationBase.vue"),
        redirect: { name: names.new },
        props: true,
        children: [
          {
            path: "",
            name: names.new,
            meta: { title: "Organization New", isNew: true },
            component: () => import("@/views/organization/OrganizationEdit.vue"),
          },
        ],
      },
      {
        path: ":id(\\d+)",
        name: names.base,
        component: () => import("@/views/organization/OrganizationBase.vue"),
        redirect: { name: names.view },
        children: [
          {
            path: "view",
            name: names.view,
            meta: { title: "Organization View" },
            component: () => import("@/views/organization/OrganizationView.vue"),
          },
          {
            path: "edit",
            name: names.edit,
            meta: { title: "Organization Edit", isForm: true },
            component: () => import("@/views/organization/OrganizationEdit.vue"),
          },
          {
            path: "organizationIncidents",
            name: names.incidentChildList,
            meta: { title: "Organization Incidents" },
            component: () => import("@/views/organization/IncidentChildList.vue"),
          },
          {
            path: "organizationSites",
            name: names.siteChildList,
            meta: { title: "Organization Sites" },
            component: () => import("@/views/organization/SiteChildList.vue"),
          },
          {
            path: "activity",
            name: names.audit,
            meta: { title: "Organization Audit Activity" },
            component: {
              render: () => <EntityAudits entityName="Organization" />,
            },
          },
        ],
      },
    ],
  },
];
export default OrganizationRoutes;
